import { PlaybackMode } from './PlaybackMode';
import { BlackoutAction } from '@quickplay/player-interface';
export enum HeartbeatAction {
  GRACEFUL_STOP = 'GRACEFUL_STOP',
  CONTINUE = 'CONTINUE',
  ABORT_ROAMING = 'ABORT_ROAMING',
  ABORT_NOT_ENTITLED = 'ABORT_NOT_ENTITLED',
  ABORT_BLACKOUT = 'ABORT_BLACKOUT',
}
/**
 * An interface for heartbeat server response
 */
export interface HeartbeatResponse {
  heartbeatToken?: string;
  blackoutUrl?: string;
  blackoutAction?: BlackoutAction;
  liveStartTime?: string;
  liveEndTime?: string;
  livePlaybackMode?: PlaybackMode;
  heartbeatAction?: HeartbeatAction;
  live360Enabled?: boolean;
  live360StartTime?: string;
  live360EndTime?: string;
  live360ContentId?: string;
  pgmId?: string;
  pgmStartTime?: string;
  pgmEndTime?: string;
  pgmBlackout?: boolean;
  custom?: { [p: string]: any };
}
